import styled from 'styled-components'

import { fontFamily } from 'common/constants'
import { media } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'
import { mobileModalPaddingSize } from 'components/storefront/StoreFrontFeaturedPhotos/FeaturedPhotos.constants'

/**
 * Отступ для краев,
 * чтобы boxShadow не обрезалось и было видно.
 */
export const boxShadowIndentDesktop = 4

export const ContactWrapper = styled(RouterLink)<{
  isEditable: boolean
}>`
  display: flex;
  transition: all 0.3s ease;
  position: relative;
  padding: 10px ${mobileModalPaddingSize}px;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  background-color: var(--static-white);
  font-family: ${fontFamily};
  ${(props) => props.theme.marginLeft}: ${(props) =>
    props.isEditable ? '40px' : '0'};

  ${media.phone`
    padding: 10px ${mobileModalPaddingSize + boxShadowIndentDesktop}px;
  `}
`

export const ContactItemWrapperAvatar = styled.div`
  width: 60px;
  height: 60px;
  display: block;
  overflow: hidden;
  border-radius: 10px;
`

interface ContactWrapperCheckboxProps {
  $isVisible: boolean
}

export const ContactWrapperCheckbox = styled.div<ContactWrapperCheckboxProps>`
  position: absolute;
  visibility: ${(props) => createStyleVisibility(props)};
  transition: all 0.2s ease;
  ${(props) => props.theme.left}: -40px;

  top: 50%;
  transform: translateY(-50%);
`

export const Shadow = styled.div<ContactWrapperCheckboxProps>`
  position: absolute;
  width: 50px;
  top: 0;
  ${(props) => props.theme.right}: 0;

  height: 100%;
  visibility: ${(props) => createStyleVisibility(props)};
  transition: all 0.3s ease-in;
  background-image: linear-gradient(
    to left,
    var(--static-white) 80%,
    rgba(var(--static-white-rgb), 0.3)
  );
`

export const ContactWrapperDiv = styled.div`
  position: relative;
  max-height: 60px;
`

export function createStyleVisibility(props: ContactWrapperCheckboxProps) {
  return props.$isVisible ? 'visible' : 'hidden'
}
